import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Button as Button$1 } from '../../Button/Button.js';
import { Icon } from '../../Icon/Icon.js';

function CloseConfirmationDialog(_ref) {
  let {
    visible,
    config,
    onCancel,
    onConfirm
  } = _ref;
  const {
    title,
    dialogName,
    confirmLabel = 'Discard & Close',
    cancelLabel = 'Cancel'
  } = config;
  function HeaderContent() {
    return jsxs("div", {
      className: "flex flex-row justify-content-between align-items-center w-full",
      children: [jsx("div", {
        className: "flex align-items-center",
        children: title
      }), jsx(Button$1, {
        icon: jsx(Icon, {
          name: "cancel",
          fontSize: "normal"
        }),
        rounded: true,
        text: true,
        className: "button-size-small",
        onClick: onCancel
      })]
    });
  }
  return jsxs(Dialog, {
    visible: visible,
    modal: true,
    draggable: false,
    header: jsx(HeaderContent, {}),
    closable: false,
    className: "dialog-close-confirmation",
    onHide: onCancel,
    children: [jsxs("p", {
      className: "mt-0 mb-4",
      children: ["You have unsaved changes in ", jsx("strong", {
        children: dialogName
      }), ". Closing this window will discard them."]
    }), jsxs("div", {
      className: "flex gap-2 justify-content-end",
      children: [jsx(Button, {
        label: cancelLabel,
        severity: "secondary",
        onClick: onCancel
      }), jsx(Button$1, {
        label: confirmLabel,
        onClick: onConfirm
      })]
    })]
  });
}

export { CloseConfirmationDialog };
